import { FormattedMessage } from 'react-intl';
import { Region, regionSelector } from '../../region/regionSlice';
import { AemLink } from '../../registration/AemLink';
import { useAppSelector } from '../../../configuration/setup/hooks';
import type { PropsWithChildren } from 'react';

export const PersonalExplanation = () => {
    const region = useAppSelector(regionSelector);
    return (
        <RegionWrapper region={region}>
            {region === Region.latinamerica && (
                <div className={'text-bold'}>
                    <FormattedMessage id={'registration.personalData.gtcApprove.link.rioPlatform'} />
                </div>
            )}

            <FormattedMessage
                id={'registration.personalData.gtcApprove.v2'}
                values={{
                    access: <AemLink aemKey={'access'} />,
                    conditions: <AemLink aemKey={'conditions'} />,
                    contract: <AemLink aemKey={'contract'} />,
                    privacy: <AemLink aemKey={'privacy'} />,
                }}
            />
            <br />
            <br />
            {region === Region.latinamerica ? (
                <div>
                    <div className={'text-bold'}>
                        <FormattedMessage id={'registration.personalData.gtcApprove.link.essentials'} />
                    </div>
                    <FormattedMessage
                        id={'registration.personalData.gtcApprove.essentials'}
                        values={{
                            specs: <AemLink aemKey={'serviceSpecs'} />,
                            serviceTerms: <AemLink aemKey={'serviceTerms'} />,
                        }}
                    />
                    <br />
                    <i>
                        <FormattedMessage id={'registration.personalData.gtcApprove.technicalDetails'} />
                    </i>
                    <br />
                    <br />
                </div>
            ) : null}
        </RegionWrapper>
    );
};

const RegionWrapper = (props: PropsWithChildren<{ region: Region | undefined }>) => {
    // only latam needs a panel wrapper around the explanation at the moment. This wrapper component manages this logic
    // the margin-top-10 is used to give some distance to the message that is displayed next to the checkbox
    if (props.region === Region.latinamerica) {
        return (
            <div className={'row margin-top-10'}>
                <div className={'col-xs-11  text-justify'}>
                    <div className={'panel panel-default margin-bottom-0'}>
                        <div className={'panel-body'}>{props.children}</div>
                    </div>
                </div>
            </div>
        );
    }
    return <div>{props.children}</div>;
};
